/* eslint-disable */
import { Fragment, useState, useEffect } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { XMarkIcon, Bars3Icon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import DisplayForm from './DisplayForm';


function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const navigation = [
  { name: 'Home', href: '/details' },
  { name: 'The Top-Live', href: '/TheTopLive' },
  { name: 'Become an Uploader', href: '/BecomeUploaderNew' },


];


export default function HomeHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { route, signOut } = useAuthenticator((context) => [
    context.route,
    context.signOut,
  ]);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function logOut() {
    console.log('Logging out');
    signOut();
    navigate('/login');
  }

  return (
    <>
    
      <Popover as="header" className="bg-white shadow-sm lg:static lg:overflow-y-visible">
        {({ open }) => (
          <>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <div className="relative flex justify-between lg:gap-8 xl:grid xl:grid-cols-12">
                <div className="flex md:absolute md:inset-y-0 md:left-0 lg:static xl:col-span-2">
                  <div className="flex flex-shrink-0 items-center">
                    <b>Kolandium</b>
                  </div>
                </div>

                {/* Sidebar */}
                <Transition
                  show={open || mobileMenuOpen}
                  as={Fragment}
                  enter="transition-opacity duration-200"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="transition-opacity duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Popover.Panel focus static className="lg:hidden">
                    <div className="fixed inset-0 z-40 flex">
                      <Transition.Child
                        as={Fragment}
                        enter="transition-opacity duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Popover.Overlay className="fixed inset-0 bg-black opacity-25" />
                      </Transition.Child>
                      <Transition.Child
                        as={Fragment}
                        enter="transition ease-in-out duration-300 transform"
                        enterFrom="-translate-x-full"
                        enterTo="translate-x-0"
                        leave="transition ease-in-out duration-300 transform"
                        leaveFrom="translate-x-0"
                        leaveTo="-translate-x-full"
                      >
                        <div className="relative flex flex-col flex-1 w-full max-w-xs bg-white shadow-xl">
                          <div className="absolute top-0 right-0 -mr-14 p-1">
                            <Popover.Button
                              className="flex items-center justify-center p-2 rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                              onClick={() => setMobileMenuOpen(false)}
                            >
                              <span className="sr-only">Close sidebar</span>
                              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </Popover.Button>
                          </div>
                          <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                            <div className="flex items-center justify-center mb-5">
                              <b>Kolandium</b>
                            </div>
                            <nav className="mt-5">
                              <div className="grid gap-y-8">
                                {navigation.map((item) => (
                                  <Link
                                    key={item.name}
                                    to={item.href}
                                    className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-100"
                                  >
                                    <span className="ml-3 text-base font-medium text-gray-900">{item.name}</span>
                                  </Link>
                                ))}
                              </div>
                            </nav>
                          </div>
                          <div className="flex-shrink-0 flex justify-end p-4">
                            {route !== 'authenticated' ? (
                              <Link
                                to="/login"
                                className="text-sm font-medium text-gray-900 hover:text-gray-700"
                              >
                                Log in
                              </Link>
                            ) : (
                              <button
                                className="text-sm font-medium text-gray-900 hover:text-gray-700"
                                onClick={() => logOut()}
                              >
                                Log out
                              </button>
                            )}
                          </div>
                        </div>
                      </Transition.Child>
                      <div className="flex-shrink-0 w-14" aria-hidden="true" />
                    </div>
                  </Popover.Panel>
                </Transition>

                <div className="min-w-0 flex-1 md:px-8 lg:px-0 xl:col-span-6">
                  <div className="flex items-center px-6 py-4 md:mx-auto md:max-w-3xl lg:mx-0 lg:max-w-none xl:px-0">
                    <div className="hidden lg:ml-6 lg:flex lg:space-x-8">
                    <a
                    href="#"
                    className="hover:scale-110 transition duration-100 inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  >
                  <Link to="/details">Home</Link>
                  </a>
                      <a
                        href="#"
                        className="hover:scale-110 transition duration-100 inline-flex items-center border-b-2 border-transparent px-1 pt-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
                      >
                      <Link to="/TheTopLive">The Top-Live</Link>
                      </a>
                      
                    </div>
                    <div>
                      <label htmlFor="search" className="sr-only">
                        Search
                      </label>
                      <div className="relative">
                        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                          <MagnifyingGlassIcon className="ml-4 h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                        <input
                          id="search"
                          name="search"
                          className="hover:scale-110 transition duration-100 ml-4 block w-full rounded-md border-0 bg-white py-1.5 pl-10 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-500 sm:text-sm sm:leading-6"
                          placeholder="Search"
                          type="search"
                        />
                        
                      </div>
                    </div>
                  
                  </div>
                </div>

                <div className="hidden lg:flex lg:items-center lg:justify-end xl:col-span-4">
                  <div className="ml-4 py-6">
                    {route !== 'authenticated' ? (
                      <Link
                        to="/login"
                        className="text-sm font-semibold leading-6 text-gray-900"
                      >
                        Log in <span aria-hidden="true">&rarr;</span>
                      </Link>
                    ) : (
                      <button
                        className="hover:scale-110 transition duration-100 text-sm font-semibold leading-6 text-gray-900"
                        onClick={() => logOut()}
                      >
                        Log out <span aria-hidden="true">&rarr;</span>
                      </button>
                    )}
                  </div>
                </div>

              
                <div className="lg:hidden mt-3">
                  <Popover.Button
                    className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  >
                    <span className="sr-only">Open main menu</span>
                    {mobileMenuOpen ? (
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    )}
                  </Popover.Button>
                </div>
              </div>
            </div>
          </>
        )}
      </Popover>
      <div className="mt-10">
       <DisplayForm/>
      </div>
    </>
  );
}
